var lightbox = {
    init: function() {
        $( 'a[data-rel^=lightcase]' ).lightcase( {
            maxWidth: 2560,
            maxHeight: 1600,
            showSequenceInfo: false,
            overlayOpacity: 1,
            shrinkFactor: 0.9
        } );
    }
}

export { lightbox };